import { MARKER_SECTOR_DEFAULT_SIZE } from "./marker-sector.constant";

export const scaleMarkerSectorSize = (scale: number = 1) => ({
  width: MARKER_SECTOR_DEFAULT_SIZE.width * scale,
  height: MARKER_SECTOR_DEFAULT_SIZE.height * scale,
});
